import { api } from '../api';

export const articleService = {
  async fetchShareArticles(params, cancelToken) {
    return api.get('articles/share', { params, cancelToken: cancelToken.token });
  },

  async fetchArticlesLinks(params, cancelToken) {
    return api.get('articles/links', { params, cancelToken: cancelToken.token });
  },

  async fetchArticlesTopLinks(params, cancelToken) {
    return api.get('articles/top-links', { params, cancelToken: cancelToken.token });
  },

  async fetchArticles(params, cancelToken) {
    return api.get('articles', { params, cancelToken: cancelToken.token });
  },

  async fetchStepArticles(params, cancelToken) {
    return api.get('articles/step', { params, cancelToken: cancelToken.token });
  },

  async fetchArticle(id) {
    return api.get('articles/' + id);
  },

  async fetchShareArticle(id) {
    return api.get('articles/share/' + id);
  },

  async createArticle(params) {
    return api.post('articles', params);
  },

  async updateArticle(id, params) {
    return api.post('articles/' + id, { '_method': 'PUT', ...params });
  },

  async uploadAttachment(params) {
    return api.post('articles/attachment', params);
  },

  async generateUrl(params) {
    return api.post('articles/share/generate-url', params);
  },

  async reportArticle(id, params) {
    return api.post('articles/' + id + '/report', params);
  },

  async searchImages(params, cancelToken) {
    return api.get('articles/search/images', { params, cancelToken: cancelToken.token });
  },

  async checkArticle(params,) {
    return api.post('articles/check', params);
  },

  async fetchArticlesRequests(params) {
    return api.get('articles/requests', { params });
  },

  async fetchArticleRequest(id) {
    return api.get('articles/requests/' + id);
  },
  
  async createArticleRequest(params) {
    return api.post('articles/requests', params);
  },

  async updateArticleRequest(id, params) {
    return api.post('articles/requests/' + id, { '_method': 'PUT', ...params });
  },

  async catchArticleRequest(id) {
    return api.put('articles/requests/' + id + '/catch');
  },

  async generateArticle(params,) {
    return api.post('articles/generate', params);
  },

  async verifyText(params) {
    return api.post('/articles/verify-text', params);
  },

  async generateTitles(id) {
    return api.post(`articles/${id}/generate-titles`);
  },
};